import React from "react";

/* Значки раздела «Задачи»: тонкие, одного размера, цвет берут у текста кнопки. */

const Svg = ({ children, size = 18 }) => (
    <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        {children}
    </svg>
);

export const IconPlus = (props) => <Svg {...props}><path d="M12 5v14M5 12h14" /></Svg>;
export const IconRefresh = (props) => (
    <Svg {...props}><path d="M20 11a8 8 0 0 0-14.3-4.3L4 8.5M4 4v4.5h4.5M4 13a8 8 0 0 0 14.3 4.3l1.7-1.8M20 20v-4.5h-4.5" /></Svg>
);
export const IconPin = ({ filled = false, ...props }) => (
    <Svg {...props}>
        <path
            d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.8-5.2 2.8 1-5.8-4.3-4.1 5.9-.9z"
            fill={filled ? "currentColor" : "none"}
        />
    </Svg>
);
export const IconEyeOff = (props) => (
    <Svg {...props}><path d="M3 3l18 18M10.6 6.2A9.7 9.7 0 0 1 12 6c5 0 8.5 4.2 9.5 6-.4.8-1.3 2-2.6 3.2M6.3 7.7C4.4 9 3.1 10.8 2.5 12c1 1.8 4.5 6 9.5 6 1.3 0 2.5-.3 3.6-.7M9.9 9.9a3 3 0 0 0 4.2 4.2" /></Svg>
);
export const IconEye = (props) => (
    <Svg {...props}><path d="M2.5 12c1-1.8 4.5-6 9.5-6s8.5 4.2 9.5 6c-1 1.8-4.5 6-9.5 6s-8.5-4.2-9.5-6z" /><circle cx="12" cy="12" r="3" /></Svg>
);
export const IconUsers = (props) => (
    <Svg {...props}><circle cx="9" cy="8.5" r="3.2" /><path d="M3 19c.5-3.2 3-5 6-5s5.5 1.8 6 5M16 5.6a3.2 3.2 0 0 1 0 5.8M17.5 14.3c2 .6 3.2 2.3 3.5 4.7" /></Svg>
);
export const IconTrash = (props) => (
    <Svg {...props}><path d="M4 7h16M9.5 7V4.5h5V7M6.5 7l.8 12.5h9.4L17.5 7M10 11v5.5M14 11v5.5" /></Svg>
);
export const IconLeave = (props) => (
    <Svg {...props}><path d="M14 4.5H6.5v15H14M10.5 12H20M16.5 8.5L20 12l-3.5 3.5" /></Svg>
);
export const IconList = (props) => (
    <Svg {...props}><path d="M9 6.5h11M9 12h11M9 17.5h11" /><circle cx="4.5" cy="6.5" r="1" /><circle cx="4.5" cy="12" r="1" /><circle cx="4.5" cy="17.5" r="1" /></Svg>
);
export const IconCalendar = (props) => (
    <Svg {...props}><rect x="3.5" y="5" width="17" height="15.5" rx="2.5" /><path d="M3.5 10h17M8 3v4M16 3v4" /></Svg>
);
export const IconChat = (props) => (
    <Svg {...props}><path d="M4 5.5h16v11H9.5L5 20v-3.5H4z" /></Svg>
);
export const IconChevron = ({ open = false, ...props }) => (
    <Svg {...props}><path d={open ? "M6 9.5l6 6 6-6" : "M9.5 6l6 6-6 6"} /></Svg>
);
